export default {
      id: "peoples-usage",
      viewBox: "0 0 128 128",
      url: __webpack_public_path__ + "static/img/icons.d90c56e0.svg#peoples",
      toString: function () {
        return this.url;
      }
    }